import { render, staticRenderFns } from "./RunInfo.vue?vue&type=template&id=130c4446&"
import script from "./RunInfo.vue?vue&type=script&lang=ts&"
export * from "./RunInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports